module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-06@2x-d7f520598971834cca8849027609c62a.webp";